module.exports = __webpack_public_path__ + "media/images/athletes/1906-a89adb993b7e8476a51b35f20492bf44.png";